import {
  Component,
  Input,
  OnInit,
  HostListener,
  AfterViewInit,
} from "@angular/core";

interface ImageItem {
  promoId: string;
  imageURL: string;
  width: number;
  height: number;
  sizePercentage: number;
}

/** @title image-resizer-list  */
@Component({
  selector: "app-image-resizer-list",
  templateUrl: "./image-resizer-list.component.html",
  styleUrls: ["./image-resizer-list.component.css"],
})
export class ImageResizerListComponent implements OnInit {
  @Input() images: ImageItem[];
  rowImages: ImageItem[][] = [];


  ngOnInit() {
    this.onWindowsResize();
    console.log(this.images);
  }

  ngAfterViewInit() {
    this.groupImagesByRow();
    console.log(this.images);
  }

  @HostListener("window:resize")
  onWindowsResize() {
    this.images.forEach((image) => {
      let relativeWidth =
        (this.calculateScreenWidth() * image.sizePercentage) / 100;
      image.width = Math.min(
        relativeWidth,
        1600 * (image.sizePercentage / 100)
      );
    });
  }

  // calculateScreenWidth(){
  //   const windowWidth = window.innerWidth;
  //   const sidebarSizePercentage = 15;
  //   //let sidebarWidth = (windowWidth - sidebarSizePercentage)/100;
  //   let sidebarWidth = (windowWidth - sidebarSizePercentage)/100;
  //   return windowWidth - sidebarWidth;
  // }

  calculateScreenWidth(){
    const windowWidth = window.innerWidth;
    const sidebarSizePercentage = 15;
    //let sidebarWidth = (windowWidth - sidebarSizePercentage)/100;
    let sidebarWidth = (windowWidth * sidebarSizePercentage)/100;
    return Math.min(windowWidth - sidebarWidth, 1600);
  }

  // groupImagesByRow() {
  //   this.rowImages = [];
  //   let currentRow: ImageItem[] = [];
  //   let rowWidth = 0;
  //   let remainingPercentage = 100;

  //   this.images.forEach((image) => {
  //     // console.log(rowWidth + image.width);
  //     // console.log(this.calculateScreenWidth());
  //     if (rowWidth + image.width <= window.innerWidth || currentRow.length === 0) {
  //       currentRow.push(image);
  //       rowWidth += image.width;
  //       remainingPercentage -= image.sizePercentage;
  //       //console.log("If statement: " + remainingPercentage);
  //     } else {
  //       console.log("Else statement: " + remainingPercentage);
  //       console.log(image);
  //       this.distributeRemainingPercentage(currentRow, remainingPercentage);
  //       this.rowImages.push(currentRow);
  //       currentRow = [image];
  //       rowWidth = image.width;
  //       remainingPercentage = 100 - image.sizePercentage;
  //     }
  //   });

  //   if (currentRow.length > 0) {
  //       this.distributeRemainingPercentage(currentRow, remainingPercentage);
  //       this.rowImages.push(currentRow);
  //   }
  //   console.log(this.rowImages);
  //   this.adjustImageHeight();
  // }

  /** This version of the function uses percentages instead of width values for clearer
   * understanding of how the space is being filled up.
   */
  groupImagesByRow() {
    this.rowImages = [];
    let currentRow: ImageItem[] = [];
    let rowPercentage = 0;
    let remainingPercentage = 100;

    this.images.forEach((image) => {
      // console.log(rowWidth + image.width);
      // console.log(this.calculateScreenWidth());
      if (rowPercentage + image.sizePercentage <= 100 || currentRow.length === 0) {
        currentRow.push(image);
        rowPercentage += image.sizePercentage;
        remainingPercentage -= image.sizePercentage;
        //console.log("If statement: " + remainingPercentage);
      } else {
        this.distributeRemainingPercentage(currentRow, remainingPercentage);
        this.rowImages.push(currentRow);
        currentRow = [image];
        rowPercentage = image.sizePercentage;
        remainingPercentage = 100 - image.sizePercentage;
      }
    });

    if (currentRow.length > 0) {
        this.distributeRemainingPercentage(currentRow, remainingPercentage);
        this.rowImages.push(currentRow);
    }
    console.log(this.rowImages);
    this.adjustImageHeight();
  }

  adjustImageHeight() {
    this.rowImages.forEach((row) => {
      const rowHeightSum = row.reduce(
        (total, image) => total + Number(image.height),
        0
      );
    //   console.log(rowHeightSum);
      const averageHeight = rowHeightSum / row.length;
    //   console.log(averageHeight);
      row.forEach((image) => (image.height = averageHeight));
    });
  }

  // distributeRemainingPercentage(row: ImageItem[], remainingPercentage: number) {
  //   if (remainingPercentage <= 0) return;
  //   const totalImages = row.length;
  //   const percentageToAdd = remainingPercentage / totalImages;
  
  //   row.forEach((image) => {
  //       console.log(percentageToAdd);
  //     image.sizePercentage += percentageToAdd;
  //     image.width = this.calculateScreenWidth() * image.sizePercentage / 100;
  //     console.log(image);
  //   });
  //   //console.log(row);
  // }

  /** This function makes sure that if an image doesn't fit the current row, that it is 
   * resized to fit the screen of the next row. This is still a testing function because 
   * essentially it should be able to determine when an image is too large and when 
   * an image is to small to cover the remainin space. 
   */
  distributeRemainingPercentage(row: ImageItem[], remainingPercentage: number) {
    if (remainingPercentage === 0) return;
    const rowPercentageSum = row.reduce((total, image) => total + Number(image.sizePercentage), 0);
    const excessPercentage = rowPercentageSum - 100;
    const adjustmentPercentage = excessPercentage / row.length;
    console.log(adjustmentPercentage);
    row.forEach((image) => {
      image.sizePercentage -= adjustmentPercentage;
      image.width = this.calculateScreenWidth() * (image.sizePercentage / 100);
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/image-resizer-list/image-resizer-list.component.ts